module.exports = __webpack_public_path__ + "b6f73df4841592e01a54c127dc553108.png";